import classNames from 'classnames';
import './List.scss';
import IListProps from './ListProps';

const List = ({ stroke, stripe, hover, className, children, ...other }: IListProps) => {
  const classes = classNames(
    {
      'list': true,
      'list-stroke': stroke,
      'list-stripe': stripe,
      'list-hover': hover,
    },
    className
  );

  return (
    <div className={classes} {...other}>
      {children}
    </div>
  );
};

export default List;
